import React, { useEffect, useState } from 'react'

import { makeStyles } from '@mui/styles'
import { Link, Typography, useTheme } from '@mui/material'

import { EventObject } from './EventComponent'

interface Props {
  element?: EventObject
  active: boolean
  width?: 'small' | 'medium' | 'big'
}

const TimelineElement: React.FC<Props> = (props) => {
  const theme = useTheme()
  const elementWidth: 'small' | 'medium' | 'big' = props.width || 'big'

  const elementWidthValues = {
    big: {
      width: 300,
      height: 200,
    },
    medium: {
      width: 240,
      height: 180,
    },
    small: {
      width: 200,
      height: 150,
    },
  }

  const [imageWidth, setImageWidth] = React.useState<string>('auto')
  const [imageHeight, setImageHeight] = React.useState<string>('200px')

  const [element, setElement] = useState<EventObject | undefined>(props.element)
  const [active, setActive] = useState<boolean>(props.active)

  useEffect(() => {
    setElement(props.element)

    const img = new Image()

    if ((props.element?.event.imageUrls && props.element?.event.imageUrls[0]) || (props.element?.eventLocation?.imageUrls && props.element?.eventLocation?.imageUrls[0])) {
      img.onload = function () {
        const height = img.height
        const width = img.width
        const ratio = width / height
        if (ratio > 1.5) {
          setImageWidth('auto')
          setImageHeight(`${elementWidthValues[elementWidth].height}px`)
        } else {
          setImageWidth(`${elementWidthValues[elementWidth].width}px`)
          setImageHeight('auto')
        }
      }
      img.src = (props.element?.event.imageUrls && props.element?.event.imageUrls[0]) || (props.element?.eventLocation?.imageUrls && props.element?.eventLocation?.imageUrls[0]) || ''
    }
  }, [props.element],
  )

  const useStyles = makeStyles(() => ({
    elementContainer: {
      width: `${elementWidthValues[elementWidth].width}px`,
      height: `${elementWidthValues[elementWidth].height}px`,
      position: 'relative',
      overflow: 'hidden',
    },
    activeElement: {
      filter: 'grayscale(0%)',
    },
    textOverlay: {
      zIndex: '100',
      position: 'absolute',
      width: `${elementWidthValues[elementWidth].width - 10}px`,
      opacity: '0.8',
      backgroundColor: '#fff',
      padding: '5px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    imageContainer: {
      width: `${elementWidthValues[elementWidth].width - 10}px`,
      height: `${elementWidthValues[elementWidth].height}px`,
      overflow: 'hidden',
    },
    image: {
      width: imageWidth,
      height: imageHeight,
      cursor: 'pointer',
      filter: 'grayscale(100%)',
      '&:hover': {
        filter: 'grayscale(0%)',
      },
    },
    location: {
      textTransform: 'uppercase',
      opacity: '0.8',
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    description: {
      cursor: 'pointer',
      textTransform: 'uppercase',
      opacity: '0.8',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  }))
  const classes = useStyles()

  return (
    <div className={classes.elementContainer}>
      {element &&
        <>
          <div className={classes.textOverlay}>
            <div className={classes.location}>
              <Typography
                variant='button'
                style={{ fontWeight: '501', color: theme.palette.grey['900'] }}
              >
                {element.event.title}
              </Typography>
            </div>
            {(element.eventLocation?.caption && element.eventLocation?.linkUrl) &&
              <Typography variant='caption'>
                <Link
                  style={{ textDecoration: 'none' }}
                  color={theme.palette.grey[600]}
                  href={element.eventLocation?.linkUrl}
                  className={classes.description}
                  target='_blank'
                >{element.eventLocation?.caption}
                </Link>
              </Typography>}
          </div>
          <div className={`${classes.imageContainer}`}>
            <img
              onMouseEnter={() => setActive(true)}
              onMouseLeave={() => setActive(false)}
              className={`${classes.image} ${active ? classes.activeElement : ''}`}
              src={element.event?.imageUrls ? element.event?.imageUrls[0] : (
                element.eventLocation?.imageUrls ? element.eventLocation?.imageUrls[0] : './images/dummyEvent.jpg')}
            />
          </div>
        </>}
    </div>
  )
}

export default TimelineElement
